import { ValidationStatus } from "@/api/enums/ValidationStatus";
import { Badge } from "@/components/atoms/Badge";

interface FormationAttestationsStatusBadgeProps {
  status: ValidationStatus;
}

const FormationAttestationsStatusBadge = ({
  status,
}: FormationAttestationsStatusBadgeProps) => {
  switch (status) {
    case ValidationStatus.UNAVAILABLE:
    case ValidationStatus.REFUSED:
      return <Badge variant="orange">En attente dépôt</Badge>;
    case ValidationStatus.PENDING:
      return <Badge variant="red">À valider</Badge>;
    case ValidationStatus.VALIDATED:
      return <Badge variant="green">Validé</Badge>;
  }
};

export default FormationAttestationsStatusBadge;
